import type { RsvpStatus } from '@guabi/shared';

const tones = {
  attending: 'bg-status-attendingBg text-status-attendingFg',
  pending: 'bg-status-pendingBg text-status-pendingFg',
  declined: 'bg-status-declinedBg text-status-declinedFg',
  maybe: 'bg-status-maybeBg text-status-maybeFg',
  booked: 'bg-status-bookedBg text-status-bookedFg',
  neutral: 'bg-cream text-leaf-soft',
} as const;

export type PillTone = keyof typeof tones;

export function Pill({
  tone = 'neutral',
  children,
}: {
  tone?: PillTone;
  children: React.ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-pill px-2.5 py-1 text-caption font-medium ${tones[tone]}`}
    >
      {children}
    </span>
  );
}

export const rsvpTone = (status: RsvpStatus): PillTone => status;
